// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: #f4f6f8;
  height: 100%;
}

a {
  text-decoration: none;
}

#root {
  height: 100%;
}

.dragLine {
  border-color: #3397F3 !important;
}

/* Prevent PerfectScrollbar from expanding on hover */
.ps__rail-y {
  width: 6px !important;
  right: 2px !important;
  background: transparent !important;
}

.ps__thumb-y {
  width: 6px !important;
  right: 0 !important;
  border-radius: 6px !important;
  background-color: #BDBDBD !important;
}

.ps__rail-y:hover,
.ps__rail-y.ps--clicking {
  width: 6px !important;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y.ps--clicking > .ps__thumb-y {
  width: 6px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/index.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AACA;EACE,gCAAA;AAEF;;AACA,qDAAA;AAEA;EACE,qBAAA;EACA,qBAAA;EACA,kCAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oCAAA;AACF;;AAEA;;EAEE,qBAAA;AACF;;AAEA;;EAEE,qBAAA;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  background-color: #f4f6f8;\n  height: 100%;\n}\n\na {\n  text-decoration: none;\n}\n\n#root {\n  height: 100%;\n}\n.dragLine {\n  border-color: #3397F3!important;\n}\n\n/* Prevent PerfectScrollbar from expanding on hover */\n\n.ps__rail-y {\n  width: 6px !important;\n  right: 2px !important;\n  background: transparent !important;\n}\n\n.ps__thumb-y {\n  width: 6px !important;\n  right: 0 !important;\n  border-radius: 6px !important;\n  background-color: #BDBDBD !important;\n}\n\n.ps__rail-y:hover,\n.ps__rail-y.ps--clicking {\n  width: 6px !important;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y.ps--clicking > .ps__thumb-y {\n  width: 6px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
